import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import {
  FIRST_PHASE,
  SECOND_PHASE,
  FINAL_PHASE,
  SECOND_PHASE_MILLIS,
  FINAL_PHASE_MILLIS,
  SPINNER_TIMEOUT_MILLIS,
  REDIRECT_TITLE_LABEL,
  REDIRECT_MESSAGE_LABEL,
  REDIRECT_TIMEOUT_TITLE_LABEL,
  REDIRECT_TIMEOUT_MESSAGE_LABEL
} from '../AisSpinnerConstants';
import { AriaAnnouncerProvider } from '@jpmuitk/aria-announcer';
import { ColumnLayout } from "@jpmuitk/column-layout";
import { ContentStatus } from '@jpmuitk/content-status';
import { Icon } from '@jpmuitk/icon';
import { useMediaQuery } from '@material-ui/core';
import { Button } from '@jpmuitk/button';
import { logV2AuditEventMessage } from '../../redux/loggingActions';

export default function AisSpinner({sessionToken, accessToken, setSpinnerTimeoutOccurred, retryBankRedirect}) {
  const { t } = useTranslation();
  const [phase, setPhase] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState('loading');
  const [ariaLabel, setAriaLabel] = useState("Loading");
  const [millis, setMillis] = useState(SPINNER_TIMEOUT_MILLIS);
  const isSmallScreen = useMediaQuery('(max-width:450px)');
  const [showRetryButton, setShowRetryButton] = useState(false);

  const getPhaseByTime = () => {
    if (millis > SECOND_PHASE_MILLIS) {
      return FIRST_PHASE;
    } else if (millis <= SECOND_PHASE_MILLIS && millis > FINAL_PHASE_MILLIS) {
      return SECOND_PHASE;
    } else {
      return FINAL_PHASE;
    }
  };

  const phasesMap = {
    firstPhase: {
      title: REDIRECT_TITLE_LABEL,
      message: REDIRECT_MESSAGE_LABEL,
      status: 'loading',
      ariaLabel: "Loading",

    },
    secondPhase: {
      title: REDIRECT_TITLE_LABEL,
      message: REDIRECT_MESSAGE_LABEL,
      status: 'loading',
      ariaLabel: "Loading"
    },
    finalPhase: {
      title: REDIRECT_TIMEOUT_TITLE_LABEL,
      message: REDIRECT_TIMEOUT_MESSAGE_LABEL,
      status: 'error',
      ariaLabel: "Error"
    }
  };

  const formatMillis = (ms) => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setMillis(prev => prev - 1000);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {

    const sendUiTimeoutEventLog = () => {
      logV2AuditEventMessage(
        sessionToken,
        accessToken,
        "UIWLP",
        "AIS Redirect Timeout Occurred",
        "AIS CONSENT FRAME",
        "Loading (AIS)"
      );
    };

    const currentPhase = getPhaseByTime();

    if (currentPhase !== phase) {
      setPhase(currentPhase);
      const phaseProperties = phasesMap[currentPhase];
      setStatus(phaseProperties.status);
      setTitle(phaseProperties.title);
      setMessage(phaseProperties.message);
      setAriaLabel(phaseProperties.ariaLabel);
      if (currentPhase === FINAL_PHASE) {
        sendUiTimeoutEventLog();
        setSpinnerTimeoutOccurred();
        setShowRetryButton(true);
      }
    }
  }, [millis]);

  const handleRetryButtonClick = () => {
    setShowRetryButton(false);
    retryBankRedirect();
    setMillis(SPINNER_TIMEOUT_MILLIS);
  };

  return (
    <ColumnLayout
      container
      style={{
        width: '100%',
        height: '80vh',
        justifyContent: 'center',
      }}
    >
      <ColumnLayout
        item
        style={{
          position: 'relative',
          top: '35%',
          maxWidth: isSmallScreen ? '90vw' : '30vw',
          width: '100%',
          height: '100%',
          wordBreak: 'break-word',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontSize: '3rem',
              fontWeight: 600,
              color: millis <= 0 ? '#e32b16' : 'inherit',
              marginBottom: 36,
            }}
          >
            {formatMillis(millis)}
          </span>
          <AriaAnnouncerProvider>
            <ContentStatus
              density={'low'}
              title={t(title)}
              message={t(message)}
              status={status}
              ariaLabel={ariaLabel}
            />
          </AriaAnnouncerProvider>
          {showRetryButton && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: 20,
              }}
            >
              <Button
                variant={'cta'}
                onClick={() => handleRetryButtonClick()}
                style={{
                  paddingTop: 6,
                  paddingBottom: 6,
                  height: '100%',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Icon name={'refresh'} /> {" "+ t("ais_retry")}
                </div>
              </Button>
            </div>
          )}
        </div>
      </ColumnLayout>
    </ColumnLayout>
  );
}
